import { render } from "./OnboardingGrayBtn.vue?vue&type=template&id=3f7a2867"
import script from "./OnboardingGrayBtn.vue?vue&type=script&lang=js"
export * from "./OnboardingGrayBtn.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__